const ArrowUpTrendIcon = (
  <svg
    className="fill-current"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z" />
  </svg>
);

export default ArrowUpTrendIcon;
